import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Instagram, MapPin, Phone, Mail } from 'lucide-react';

const COLS = [
  { title: 'Studio', icon: MapPin, lines: ['865 Campbell Ave.', 'Ottawa ON K2A 2C6'] },
  { title: 'Contact', icon: Phone, lines: ['+1 (613) 404-4824', 'info@supremexdetailing.ca'] },
  { title: 'Hours', icon: Mail, lines: ['Mon–Fri 8–6', 'Sat 9–4', 'By appointment'] },
];

const LINKS = [
  ['/ppf', 'Paint protection film'],
  ['/services/ceramic', 'Ceramic coating'],
  ['/services/tint', 'Window tint'],
  ['/services/wrap', 'Vinyl wrap'],
  ['/ev', 'Tesla / EV'],
  ['/build', 'Build a package'],
];

export default function Footer() {
  return (
    <footer id="contact" data-testid="site-footer" className="bg-charcoal text-white">
      <div className="px-6 md:px-10 pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <img src="/brand/logo.png" alt="SupremeX Detailing" className="h-8 w-auto" />
            <h2 className="font-display h-section mt-8 text-white">
              Bring the <span className="text-red">car.</span>
            </h2>
            <p className="mt-6 max-w-lg body text-white/60">
              Every quote begins with a walkaround at the studio. Or send photos and details and we will build the right protection sequence around it.
            </p>
            <Link to="/#book" data-testid="footer-book" className="btn btn-red mt-10">
              Book a consultation <ArrowUpRight size={14} />
            </Link>
          </div>

          {COLS.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <p className="eyebrow text-red mb-5">{c.title}</p>
              <div className="text-sm text-white/80 leading-relaxed space-y-1">
                {c.lines.map((l) => <span key={l} className="block">{l}</span>)}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="meta text-white/40">Independent website concept · Not affiliated with or endorsed by SupremeX</p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
            {LINKS.map(([to, label]) => (
              <Link key={to} to={to} data-testid={`footer-link-${to}`} className="meta text-white/60 hover:text-white transition-colors">{label}</Link>
            ))}
            <a href="https://www.instagram.com/supremexdetailing" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="text-white/50 hover:text-red transition-colors">
              <Instagram size={16} />
            </a>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <p className="text-xs leading-relaxed text-white/45 max-w-3xl">
            Prototype only. The form does not send or store information. Service details, pricing, availability, reviews, warranties, and image permissions must be confirmed with the business before production use.
          </p>
          <a href="https://supremexdetailing.ca/" target="_blank" rel="noreferrer" className="meta text-white/70 hover:text-white transition-colors shrink-0">
            Official website <ArrowUpRight size={13} className="inline ml-1" />
          </a>
        </div>
      </div>
    </footer>
  );
}
